import { ExperienceItem } from '../types';

// Dates use YYYY-MM-DD; `end: null` means "current role" and duration is computed live.
export const experience = [
  {
    isCurrent: true,
    start: '2025-11-01',
    end: null,
    location: 'Rugby, UK',
    title: 'Enterprise AI Agent Builder & Senior Backend Engineer',
    org: 'Cognizant · UK Retail Client',
    tagline: 'Solo AI Agent Architecture, Cloud Automations & Production Support',
    tags: ['LangGraph', 'OpenAI APIs', 'pgvector', 'FastAPI', 'Kubernetes', 'Kafka', 'AWS S3', 'ServiceNow'],
    bullets: [
      'Architected and developed a governed, solo multi-agent AI POC using LangChain, LangGraph, OpenAI LLM APIs, pgvector, Python, and PostgreSQL to automate enterprise SQL queries across 400+ tables.',
      'Built backend automation and workflow integrations utilizing Java, Python, ServiceNow, AWS S3, and custom API microservices.',
      'Supported production enterprise workloads involving incident diagnosis, alert investigations, and root-cause analysis across Kubernetes and Kafka architectures.',
      'Presented AI agent initiatives to business stakeholders, communicating technical architectures in terms of cost reduction, operational efficiency, and data democratization.'
    ]
  },
  {
    isCurrent: false,
    start: '2024-01-01',
    end: '2025-11-01',
    location: 'Leeds, UK',
    title: 'Software Engineer / Backend & Automation Engineer',
    org: 'Cognizant · UK Retail Client',
    tagline: 'High-Scale Loyalty Platform, Java 21 Microservices & AWS Modernization',
    tags: ['Java 21', 'AWS (ECS, SQS, DynamoDB, RDS)', 'Python', 'Datadog', 'Jenkins', 'AIOps POC'],
    bullets: [
      'Engineered and optimized the enterprise Loyalty Management Application across AWS SNS, SQS, Elasticsearch, Elasticache, ECS, DynamoDB, RDS, microservices, and Java 21 — significantly improving system stability and efficiency.',
      'Managed zero-downtime component deployment processes via automated Jenkins CI/CD pipelines.',
      'Developed Python and Java backend services for customer-facing Digital Receipt and Customer Savings features.',
      'Automated daily and weekly reporting operations using custom Python and Java automation engines.',
      'Configured Datadog and Loggly observability dashboards and proactive alerting to eliminate blind spots and prevent major production incidents.',
      'Contributed to large-scale infrastructure cloud migrations across multiple AWS accounts, ensuring seamless transitions and operational continuity.',
      'Scaled core AWS components to enhance application performance and deliver smoother high-concurrency user experiences.',
      'Engineered backend microservices integrating third-party retail partners including Emerald, Ecrebo, Eagle Eye, and Deliveroo.',
      'Spearheaded a client-consultation POC evaluating ServiceNow AIOps for self-healing infrastructure solutions to reduce incident volume.'
    ]
  },
  {
    isCurrent: false,
    start: '2020-11-01',
    end: '2024-01-01',
    location: 'India',
    title: 'Software Engineer / Backend & Automation Engineer',
    org: 'Cognizant · UK Retail Client',
    tagline: 'Enterprise Loyalty Systems, GraphQL Services & Automation Tooling',
    tags: ['Java', 'GraphQL', 'Python', 'GitLab CI/CD', 'ServiceNow', 'QuickSight', 'Looker Studio'],
    bullets: [
      'Developed and integrated SAVI and Coinstar components, enhancing loyalty application functionality and transactional data insights.',
      'Played a key engineering role in the successful re-launch of the retail Loyalty point scheme, introducing an innovative point-to-voucher conversion mechanism.',
      'Engineered core backend components handling third-party coupon processing (SAVI/Coinstar).',
      'Developed Java services facilitating high-volume migration of Loyalty Points into a modernized third-party ecosystem.',
      'Designed and deployed real-time alerting and visualization dashboards in QuickSight and Looker Studio, drastically improving operational intelligence.',
      'Built automated incident reporting engines in ServiceNow to track and visualize MTTR resolution times and categorization patterns.',
      'Engineered robust Java backend services and GraphQL APIs for enterprise loyalty application features and partner integrations.',
      'Automated repetitive engineering and operational workflows using Python, Google Apps Script, Claude, and GitHub Copilot to save manual effort.',
      'Maintained GitLab CI/CD build/deployment pipelines and supported continuous backend delivery workflows.'
    ]
  }
] as const satisfies readonly ExperienceItem[];

export default experience;
